module.exports = __webpack_public_path__ + "img/watermark-logo.b4ca0f31.png";